export function timestampFromOclock() {
    const now = new Date();
    const timestamp = (now.getUTCMinutes() * 60 + now.getUTCSeconds()) * 1000 + now.getUTCMilliseconds();
    return timestamp;
}
